<template lang="pug">
v-container( mb-4 pa-0 fluid style="margin-top: 80px !important;")
    v-layout(text-xs-center='', wrap='')
    //- v-flex(xs10 offset-xs1 sm10='' offset-sm1 offset-md1 md4)
        v-layout(column)
        
            v-flex(sm12='' md6)
            v-img.taiwan-img(src="https://svgshare.com/i/C2C.svg" contain)
    v-flex(xs10='' offset-xs1)
        br  
        h1.taiwan-vote-type-title.title-all 台灣現況
    v-flex(xs10 offset-xs1 sm10='' offset-sm1 offset-md1 md10)
        v-layout.eighteen-vote-right-layout(text-sm-center='' wrap='')
            v-flex.taiwan-vote-type-item(data-aos="zoom-in-left" :data-aos-delay="300*index" xs8='' offset-xs2 sm3='' offset-sm2 md2='' offset-md1  v-for="(type,index) in voteTypes" :key="index" @click="clickRights(index)")
                v-img.eighteen-vote-right-icon(:src="type.icon" contain  position="center center")
                br
                h3 {{type.title}}
    v-flex(xs12 offset-xs0)
      template
        .text-xs-center
          v-dialog(v-model='dialog' @input="closeDialog()" width='800')
            v-card
              v-card-title.headline.grey.lighten-2(primary-title='')
                | {{dialogTitle}}
              v-card-text.content-all(v-html="dialogContent")
              div(v-if="dialogImages.length !== 0")
                v-carousel.carousel-wrapper(hide-delimiters=true prev-icon="arrow_back" next-icon="arrow_forward")
                  v-carousel-item(v-for='(item,i) in dialogImages', :key='i', :src='item')
              v-divider
              v-card-actions
                v-spacer
                v-btn(color='primary', flat='', @click='dialog = false')
                  | 關閉視窗

</template>

<script>
export default {
  data: () => ({
    dialog: false,
    dialogTitle: "",
    dialogContent: "",
    dialogImages: [],
    voteTypes: [
      {
        title: "公民投票，人民作主？",
        content: `
            <html>
            <head>
                <meta content="text/html; charset=UTF-8" http-equiv="content-type">
                <style type="text/css">

                    *{
                        font-size: 18px;
                        line-height: 1.5;
                    }
                    .lst-kix_6wt5ocm7z4f8-7>li:before {
                        content: "\\0025cb"
                    }

                    .lst-kix_6wt5ocm7z4f8-8>li:before {
                        content: "\\0025a0"
                    }

                    ul.lst-kix_6wt5ocm7z4f8-0 {
                        list-style-type: none
                    }

                    ul.lst-kix_6wt5ocm7z4f8-2 {
                        list-style-type: none
                    }

                    ul.lst-kix_6wt5ocm7z4f8-1 {
                        list-style-type: none
                    }

                    ul.lst-kix_6wt5ocm7z4f8-4 {
                        list-style-type: none
                    }

                    ul.lst-kix_6wt5ocm7z4f8-3 {
                        list-style-type: none
                    }

                    .lst-kix_6wt5ocm7z4f8-3>li:before {
                        content: "\\0025cf"
                    }

                    .lst-kix_6wt5ocm7z4f8-1>li:before {
                        content: "\\0025cb"
                    }

                    .lst-kix_6wt5ocm7z4f8-2>li:before {
                        content: "\\0025a0"
                    }

                    .lst-kix_6wt5ocm7z4f8-0>li:before {
                        content: "\\0025cf"
                    }

                    ul.lst-kix_6wt5ocm7z4f8-6 {
                        list-style-type: none
                    }

                    .lst-kix_6wt5ocm7z4f8-4>li:before {
                        content: "\\0025cb"
                    }

                    ul.lst-kix_6wt5ocm7z4f8-5 {
                        list-style-type: none
                    }

                    ul.lst-kix_6wt5ocm7z4f8-8 {
                        list-style-type: none
                    }

                    ul.lst-kix_6wt5ocm7z4f8-7 {
                        list-style-type: none
                    }

                    .lst-kix_6wt5ocm7z4f8-5>li:before {
                        content: "\\0025a0"
                    }

                    .lst-kix_6wt5ocm7z4f8-6>li:before {
                        content: "\\0025cf"
                    }

                    ol {
                        margin: 0;
                        padding: 0
                    }

                    table td,
                    table th {
                        padding: 0
                    }

                    .c5 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 97.5pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c2 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 66.8pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c7 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 163.5pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c4 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 153.8pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c16 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 317.2pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c8 {
                        padding-top: 0pt;
                        padding-bottom: 10pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: justify;
                        height: 12pt
                    }

                    .c0 {
                        color: #000000;
                        font-weight: 400;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 12pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c6 {
                        color: #000000;
                        font-weight: 700;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 18pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c17 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.0;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .c12 {
                        padding-top: 0pt;
                        padding-bottom: 10pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .c11 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.0;
                        orphans: 2;
                        widows: 2;
                        text-align: left
                    }

                    .c3 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.0;
                        orphans: 2;
                        widows: 2;
                        text-align: center
                    }

                    .c9 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.0;
                        text-align: left;
                        height: 12pt
                    }

                    .c14 {
                        margin-left: auto;
                        border-spacing: 0;
                        border-collapse: collapse;
                        margin-right: auto
                    }

                    .c15 {
                        background-color: #ffffff;
                        max-width: 481.9pt;
                        padding: 56.7pt 56.7pt 56.7pt 56.7pt
                    }

                    .c13 {
                        height: 0pt
                    }

                    .c1 {
                        height: 22pt
                    }

                    .c10 {
                        height: 12pt
                    }

                    .title {
                        padding-top: 0pt;
                        color: #000000;
                        font-size: 26pt;
                        padding-bottom: 3pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .subtitle {
                        padding-top: 0pt;
                        color: #666666;
                        font-size: 15pt;
                        padding-bottom: 16pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    li {
                        color: #000000;
                        font-size: 12pt;
                        font-family: "Arial"
                    }

                    p {
                        margin: 0;
                        color: #000000;
                        font-size: 12pt;
                        font-family: "Arial"
                    }

                    h1 {
                        padding-top: 24pt;
                        color: #000000;
                        font-weight: 700;
                        font-size: 20pt;
                        padding-bottom: 6pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h2 {
                        padding-top: 18pt;
                        color: #000000;
                        font-size: 12pt;
                        padding-bottom: 6pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h3 {
                        padding-top: 16pt;
                        color: #434343;
                        font-size: 14pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h4 {
                        padding-top: 0pt;
                        color: #000000;
                        font-weight: 700;
                        font-size: 12pt;
                        padding-bottom: 10pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h5 {
                        padding-top: 12pt;
                        color: #666666;
                        font-size: 11pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h6 {
                        padding-top: 12pt;
                        color: #666666;
                        font-size: 11pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        font-style: italic;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }
                </style>
                </head>

                <body class="c15">
                    <p class="c12">
                        <span>當代民主制度中，為了補充代議民主裡公民常僅從「選舉」一途參與政治的不足、對政治人物的信任度低等等因素，有許多相關的制度興起。其中，公民投票就是一環，讓人民針對「事」也可表態，而不僅限於「人」。台灣的《公民投票法》也是為了落實《憲法》保障人民「創制」與「複決」之權利、確保國民能直接直接民權，並補代議政治之不足，</span><span>在許多民主前輩的努力下，終於在2013年公布施行</span><span
                            class="c0">，為我國公民投票制度之建構，確立法律基礎。</span></p>
                    <p class="c12">
                        <span>但是，自公投法施行以來，因為各階段超高的門檻被社會各界譏為「鳥籠公投」，導致第9屆立法院修法前，</span><span>不僅只有6案全國性公民投票案及5案地方性公民投票案成立，甚至只有1案通過。</span><span
                            class="c0">為符合人民期待，真正落實憲法賦予之直接民權、深化民主價值、擴大政治參與，大幅修正的公投法終於在2018年初公布施行，修正重點如下：</span></p><a
                        id="t.7eec6fb6ee16b536b2714d649556d3d079197270"></a><a id="t.0"></a>
                    <table class="c14">
                        <tbody>
                            <tr class="c13">
                                <td class="c2" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">目標</span></p>
                                </td>
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">項目</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">修正前</span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">現行規定</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c2" colspan="1" rowspan="5">
                                    <p class="c3"><span class="c0">破除鳥籠</span></p>
                                    <p class="c3 c10"><span class="c0"></span></p>
                                    <p class="c3"><span class="c0">降低門檻</span></p>
                                </td>
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">年齡</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">20歲</span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">18歲</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">全國性公投提案</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">千分之五</span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">萬分之一</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">全國性公投連署</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">百分之五</span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">百分之一點五</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">通過門檻</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c11"><span class="c0">投票人數達全國、直轄市、縣(市)投票權人總數二分之一以上，且有效投票數超過二分之一同意者</span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c11"><span class="c0">有效同意票數多於不同意票，且有效同意票達投票權人總額四分之一以上者</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">地方性公投</span></p>
                                </td>
                                <td class="c16" colspan="2" rowspan="1">
                                    <p class="c11"><span class="c0">刪除提案及連署人數規定，並修正地方性公民投票案相關事項，由直轄市、縣（市）以自治條例定之。</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c2" colspan="1" rowspan="3">
                                    <p class="c3"><span class="c0">排除<br>投票障礙<br>積極措施</span></p>
                                </td>
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">全國性主管機關</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">行政院公民投票審議委員會</span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">獨立機關中央選舉委員會</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">提案及連署方式</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3 c10"><span class="c0"></span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">主管機關建置電子系統</span></p>
                                </td>
                            </tr>
                            <tr class="c1">
                                <td class="c5" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">投票方式</span></p>
                                </td>
                                <td class="c7" colspan="1" rowspan="1">
                                    <p class="c3 c10"><span class="c0"></span></p>
                                </td>
                                <td class="c4" colspan="1" rowspan="1">
                                    <p class="c3"><span class="c0">得以不在籍投票方式為之</span></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="c8"><span class="c0"></span></p>
                    <p class="c12"><span class="c0">打開公投的鳥籠後，全國性公民投票案第7案至第16案在2018年11月24日與地方選舉同台登場，直指多項台灣民主政治歷史之最，更引起諸多討論。</span></p>
                    <p class="c8"><span class="c0"></span></p>
                    <p class="c8"><span class="c0"></span></p>
                </body>
            </html>`,
        icon:
          "data:image/svg+xml;utf8;base64,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",
        images: []
      },
      {
        title: "人民如何發動公投？",
        content: `
            <html>
            <head>
                <meta content="text/html; charset=UTF-8" http-equiv="content-type">
                <style type="text/css">
                    *{
                        font-size: 18px;
                        line-height: 1.5;
                    }
                    .lst-kix_flx31togike-8>li:before {
                        content: "\\0025a0  "
                    }

                    .lst-kix_6b5eri9xqhlz-1>li:before {
                        content: "\\0025cb  "
                    }

                    .lst-kix_flx31togike-6>li:before {
                        content: "\\0025cf  "
                    }

                    .lst-kix_6b5eri9xqhlz-2>li:before {
                        content: "\\0025a0  "
                    }

                    ul.lst-kix_flx31togike-1 {
                        list-style-type: none
                    }

                    ul.lst-kix_flx31togike-0 {
                        list-style-type: none
                    }

                    .lst-kix_flx31togike-7>li:before {
                        content: "\\0025cb  "
                    }

                    .lst-kix_6b5eri9xqhlz-0>li:before {
                        content: "\\0025cf  "
                    }

                    ul.lst-kix_6b5eri9xqhlz-1 {
                        list-style-type: none
                    }

                    ul.lst-kix_6b5eri9xqhlz-0 {
                        list-style-type: none
                    }

                    .lst-kix_flx31togike-0>li:before {
                        content: "\\0025cf  "
                    }

                    .lst-kix_flx31togike-1>li:before {
                        content: "\\0025cb  "
                    }

                    ul.lst-kix_flx31togike-8 {
                        list-style-type: none
                    }

                    ul.lst-kix_flx31togike-7 {
                        list-style-type: none
                    }

                    .lst-kix_6b5eri9xqhlz-7>li:before {
                        content: "\\0025cb  "
                    }

                    ul.lst-kix_flx31togike-6 {
                        list-style-type: none
                    }

                    ul.lst-kix_flx31togike-5 {
                        list-style-type: none
                    }

                    .lst-kix_flx31togike-2>li:before {
                        content: "\\0025a0  "
                    }

                    ul.lst-kix_flx31togike-4 {
                        list-style-type: none
                    }

                    ul.lst-kix_flx31togike-3 {
                        list-style-type: none
                    }

                    .lst-kix_6b5eri9xqhlz-6>li:before {
                        content: "\\0025cf  "
                    }

                    ul.lst-kix_flx31togike-2 {
                        list-style-type: none
                    }

                    ul.lst-kix_6b5eri9xqhlz-8 {
                        list-style-type: none
                    }

                    .lst-kix_flx31togike-4>li:before {
                        content: "\\0025cb  "
                    }

                    .lst-kix_flx31togike-5>li:before {
                        content: "\\0025a0  "
                    }

                    ul.lst-kix_6b5eri9xqhlz-7 {
                        list-style-type: none
                    }

                    .lst-kix_6b5eri9xqhlz-3>li:before {
                        content: "\\0025cf  "
                    }

                    .lst-kix_6b5eri9xqhlz-5>li:before {
                        content: "\\0025a0  "
                    }

                    ul.lst-kix_6b5eri9xqhlz-6 {
                        list-style-type: none
                    }

                    ul.lst-kix_6b5eri9xqhlz-5 {
                        list-style-type: none
                    }

                    ul.lst-kix_6b5eri9xqhlz-4 {
                        list-style-type: none
                    }

                    .lst-kix_flx31togike-3>li:before {
                        content: "\\0025cf  "
                    }

                    ul.lst-kix_6b5eri9xqhlz-3 {
                        list-style-type: none
                    }

                    ul.lst-kix_6b5eri9xqhlz-2 {
                        list-style-type: none
                    }

                    .lst-kix_6b5eri9xqhlz-4>li:before {
                        content: "\\0025cb  "
                    }

                    .lst-kix_6b5eri9xqhlz-8>li:before {
                        content: "\\0025a0  "
                    }

                    ol {
                        margin: 0;
                        padding: 0
                    }
                    html, body {
                        width: 100%;
                    }
                    table {
                        margin: 0 auto;
                    }

                    table td,
                    table th {
                        padding: 0
                    }

                    .c6 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 82.5pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c5 {
                        border-right-style: solid;
                        padding: 5pt 5pt 5pt 5pt;
                        border-bottom-color: #000000;
                        border-top-width: 1pt;
                        border-right-width: 1pt;
                        border-left-color: #000000;
                        vertical-align: middle;
                        border-right-color: #000000;
                        border-left-width: 1pt;
                        border-top-style: solid;
                        border-left-style: solid;
                        border-bottom-width: 1pt;
                        width: 399pt;
                        border-top-color: #000000;
                        border-bottom-style: solid
                    }

                    .c4 {
                        margin-left: 21.3pt;
                        padding-top: 0pt;
                        padding-left: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: left
                    }

                    .c1 {
                        color: #000000;
                        font-weight: 400;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 12pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c10 {
                        color: #000000;
                        font-weight: 400;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 18pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c3 {
                        padding-top: 0pt;
                        padding-bottom: 10pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: justify;
                        height: 12pt
                    }

                    .c15 {
                        padding-top: 0pt;
                        padding-bottom: 10pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .c2 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: center
                    }

                    .c9 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: left
                    }

                    .c13 {
                        padding-top: 0pt;
                        padding-bottom: 0pt;
                        line-height: 1.0;
                        text-align: center
                    }

                    .c12 {
                        border-spacing: 0;
                        border-collapse: collapse;
                        margin-right: auto
                    }

                    .c8 {
                        background-color: #ffffff;
                        max-width: 481.9pt;
                        padding: 56.7pt 56.7pt 56.7pt 56.7pt
                    }

                    .c7 {
                        padding: 0;
                        margin: 0
                    }

                    .c14 {
                        font-size: 18pt;
                        font-weight: 700
                    }

                    .c11 {
                        height: 12pt
                    }

                    .c0 {
                        height: 0pt
                    }

                    .title {
                        padding-top: 0pt;
                        color: #000000;
                        font-size: 26pt;
                        padding-bottom: 3pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .subtitle {
                        padding-top: 0pt;
                        color: #666666;
                        font-size: 15pt;
                        padding-bottom: 16pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    li {
                        color: #000000;
                        font-size: 12pt;
                        font-family: "Arial"
                    }

                    p {
                        margin: 0;
                        color: #000000;
                        font-size: 12pt;
                        font-family: "Arial"
                    }

                    h1 {
                        padding-top: 24pt;
                        color: #000000;
                        font-weight: 700;
                        font-size: 20pt;
                        padding-bottom: 6pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h2 {
                        padding-top: 18pt;
                        color: #000000;
                        font-size: 12pt;
                        padding-bottom: 6pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h3 {
                        padding-top: 16pt;
                        color: #434343;
                        font-size: 14pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h4 {
                        padding-top: 0pt;
                        color: #000000;
                        font-weight: 700;
                        font-size: 12pt;
                        padding-bottom: 10pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h5 {
                        padding-top: 12pt;
                        color: #666666;
                        font-size: 11pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h6 {
                        padding-top: 12pt;
                        color: #666666;
                        font-size: 11pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        font-style: italic;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }
                </style>
            </head>

            <body class="c8">
                <p class="c9"><span class="c1">依據我國《公民投票法》第三章所規定的「公民投票程序」，要發動公投，必須分成以下的程序進行：</span></p>
                <p class="c9 c11"><span class="c1"></span></p><a id="t.689ad604010aba4811e975fe5b3b63d8d3a2649b"></a><a
                    id="t.0"></a>
                <table class="c12">
                    <tbody>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c2"><span class="c1">ㄧ、提案：</span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0 start">
                                    <li class="c4"><span class="c1">領銜人檢具公投案主文、理由書、提案人正本與影本名冊，向主管機關提出。</span></li>
                                    <li class="c4"><span class="c1">除紙本連署外，也能電子提案。</span></li>
                                    <li class="c4"><span class="c1">公投提案門檻為最近一次總統選舉人數的萬分之1。 </span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c2"><span class="c1">二、審查：</span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0">
                                    <li class="c4"><span class="c1">主管機關收到提案，應該在30日內完成審核。</span></li>
                                    <li class="c4"><span class="c1">若公投題目不適用公投項目、提案人未符合相關規定、文不對題等，必須限30日內補正，補正機會以1次為限。 </span></li>
                                    <li class="c4"><span class="c1">戶政機關查對提案人名冊確定無誤，15 日內完成，通知連署人領取連署表格。</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c2"><span class="c1">三、連署：</span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0">
                                    <li class="c4"><span class="c1">提案人在主管機關通知後，10日內領取紙本連署表格，紙本或電子連署必須在6個月內完成。</span></li>
                                    <li class="c4"><span class="c1">連署人數需達提案時最近一次總統大選選舉人數1.5%。 </span></li>
                                    <li class="c4"><span class="c1">主管機關收到連署人名冊後，戶政機關需在30日內完成查對，若需補提也要在30日內完成。</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c2"><span class="c1">四、宣傳： </span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0">
                                    <li class="c4"><span class="c1">公投案成立公告後，正反雙方都可經許可設立辦事處，募款、宣傳。</span></li>
                                    <li class="c4"><span
                                            class="c1">主管機關要在投票日28天前，公告投票日期、公投內容。並且透過公費在全國性無線電視頻道提供時段，供正反意見進行辯論，全國至少5場。</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c2"><span class="c1">五、投票：</span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0">
                                    <li class="c4"><span class="c1">主管機關應在公投案公告成立後1至6個月內舉行公投，期間有全國性選舉，應與同日舉行。</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c2"><span class="c1">六、結果：</span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0">
                                    <li class="c4"><span class="c1">通過門檻則是有效同意票達投票權人總額25%後，同意票相對多數就算通過。</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="c0">
                            <td class="c6" colspan="1" rowspan="1">
                                <p class="c13"><span class="c1">補充說明</span></p>
                            </td>
                            <td class="c5" colspan="1" rowspan="1">
                                <ul class="c7 lst-kix_6b5eri9xqhlz-0">
                                    <li class="c4"><span class="c1">全國性公投主管機關為中選會</span></li>
                                    <li class="c4"><span class="c1">地方性公投為地方政府，提案和連署門檻由地方政府定之</span></li>
                                    <li class="c4"><span class="c1">此次修法開放18歲以上國民，可進行連署與公投</span></li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p class="c9"><span class="c1"></span></p>
                <p class="c3"><span class="c1"></span></p>
            </body>
            </html>`,
        icon:
          "data:image/svg+xml;utf8;base64,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",
        images: []
      },
      {
        title: "行政、立法部門發動公投？",
        content: `
            <html>
                <head>
                    <meta content="text/html; charset=UTF-8" http-equiv="content-type">
                    <style type="text/css">
                        *{
                            font-size: 18px;
                            line-height: 1.5;
                        }
                        ul.lst-kix_ontk7jkumbsj-0 {
                            list-style-type: none
                        }

                        ul.lst-kix_ontk7jkumbsj-1 {
                            list-style-type: none
                        }

                        .lst-kix_ia1bhn391by9-1>li:before {
                            content: "\\0025cb  "
                        }

                        .lst-kix_ia1bhn391by9-3>li:before {
                            content: "\\0025cf  "
                        }

                        .lst-kix_ia1bhn391by9-0>li:before {
                            content: "\\0025cf  "
                        }

                        .lst-kix_ia1bhn391by9-4>li:before {
                            content: "\\0025cb  "
                        }

                        .lst-kix_ia1bhn391by9-2>li:before {
                            content: "\\0025a0  "
                        }

                        .lst-kix_ontk7jkumbsj-6>li:before {
                            content: "\\0025cf  "
                        }

                        .lst-kix_ontk7jkumbsj-7>li:before {
                            content: "\\0025cb  "
                        }

                        ul.lst-kix_ia1bhn391by9-0 {
                            list-style-type: none
                        }

                        .lst-kix_ontk7jkumbsj-5>li:before {
                            content: "\\0025a0  "
                        }

                        ul.lst-kix_ia1bhn391by9-2 {
                            list-style-type: none
                        }

                        ul.lst-kix_ia1bhn391by9-1 {
                            list-style-type: none
                        }

                        ul.lst-kix_ia1bhn391by9-4 {
                            list-style-type: none
                        }

                        ul.lst-kix_ia1bhn391by9-3 {
                            list-style-type: none
                        }

                        ul.lst-kix_ia1bhn391by9-6 {
                            list-style-type: none
                        }

                        ul.lst-kix_ia1bhn391by9-5 {
                            list-style-type: none
                        }

                        ul.lst-kix_ia1bhn391by9-8 {
                            list-style-type: none
                        }

                        .lst-kix_ontk7jkumbsj-0>li:before {
                            content: "\\0025cf  "
                        }

                        .lst-kix_ontk7jkumbsj-8>li:before {
                            content: "\\0025a0  "
                        }

                        ul.lst-kix_ia1bhn391by9-7 {
                            list-style-type: none
                        }

                        .lst-kix_ontk7jkumbsj-1>li:before {
                            content: "\\0025cb  "
                        }

                        .lst-kix_ia1bhn391by9-8>li:before {
                            content: "\\0025a0  "
                        }

                        ul.lst-kix_ontk7jkumbsj-6 {
                            list-style-type: none
                        }

                        .lst-kix_ontk7jkumbsj-2>li:before {
                            content: "\\0025a0  "
                        }

                        .lst-kix_ontk7jkumbsj-3>li:before {
                            content: "\\0025cf  "
                        }

                        ul.lst-kix_ontk7jkumbsj-7 {
                            list-style-type: none
                        }

                        ul.lst-kix_ontk7jkumbsj-8 {
                            list-style-type: none
                        }

                        .lst-kix_ia1bhn391by9-5>li:before {
                            content: "\\0025a0  "
                        }

                        .lst-kix_ia1bhn391by9-7>li:before {
                            content: "\\0025cb  "
                        }

                        ul.lst-kix_ontk7jkumbsj-2 {
                            list-style-type: none
                        }

                        ul.lst-kix_ontk7jkumbsj-3 {
                            list-style-type: none
                        }

                        .lst-kix_ontk7jkumbsj-4>li:before {
                            content: "\\0025cb  "
                        }

                        ul.lst-kix_ontk7jkumbsj-4 {
                            list-style-type: none
                        }

                        ul.lst-kix_ontk7jkumbsj-5 {
                            list-style-type: none
                        }

                        .lst-kix_ia1bhn391by9-6>li:before {
                            content: "\\0025cf  "
                        }

                        ol {
                            margin: 0;
                            padding: 0
                        }
                        
                        table{
                            margin: 0 auto;
                        }

                        table td,
                        table th {
                            padding: 0
                        }

                        .c11 {
                            border-right-style: solid;
                            padding: 5pt 5pt 5pt 5pt;
                            border-bottom-color: #000000;
                            border-top-width: 1pt;
                            border-right-width: 1pt;
                            border-left-color: #000000;
                            vertical-align: middle;
                            border-right-color: #000000;
                            border-left-width: 1pt;
                            border-top-style: solid;
                            border-left-style: solid;
                            border-bottom-width: 1pt;
                            width: 158.2pt;
                            border-top-color: #000000;
                            border-bottom-style: solid
                        }

                        .c8 {
                            border-right-style: solid;
                            padding: 5pt 5pt 5pt 5pt;
                            border-bottom-color: #000000;
                            border-top-width: 1pt;
                            border-right-width: 1pt;
                            border-left-color: #000000;
                            vertical-align: middle;
                            border-right-color: #000000;
                            border-left-width: 1pt;
                            border-top-style: solid;
                            border-left-style: solid;
                            border-bottom-width: 1pt;
                            width: 323.2pt;
                            border-top-color: #000000;
                            border-bottom-style: solid
                        }

                        .c3 {
                            padding-top: 0pt;
                            text-indent: 21.3pt;
                            padding-bottom: 10pt;
                            line-height: 1.15;
                            orphans: 2;
                            widows: 2;
                            text-align: justify;
                            height: 12pt
                        }

                        .c15 {
                            color: #000000;
                            font-weight: 700;
                            text-decoration: none;
                            vertical-align: baseline;
                            font-size: 18pt;
                            font-family: "Arial";
                            font-style: normal
                        }

                        .c6 {
                            color: #000000;
                            font-weight: 700;
                            text-decoration: none;
                            vertical-align: baseline;
                            font-size: 14pt;
                            font-family: "Arial";
                            font-style: normal
                        }

                        .c1 {
                            margin-left: 36pt;
                            padding-top: 0pt;
                            padding-bottom: 10pt;
                            line-height: 1.15;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        .c0 {
                            color: #000000;
                            font-weight: 400;
                            text-decoration: none;
                            vertical-align: baseline;
                            font-size: 12pt;
                            font-family: "Arial";
                            font-style: normal
                        }

                        .c4 {
                            padding-top: 0pt;
                            padding-bottom: 10pt;
                            line-height: 1.15;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        .c10 {
                            padding-top: 0pt;
                            padding-bottom: 10pt;
                            line-height: 1.15;
                            orphans: 2;
                            widows: 2;
                            text-align: center
                        }

                        .c16 {
                            border-spacing: 0;
                            border-collapse: collapse;
                            margin-right: auto
                        }

                        .c7 {
                            background-color: #ffffff;
                            max-width: 481.9pt;
                            padding: 56.7pt 56.7pt 56.7pt 56.7pt
                        }

                        .c2 {
                            padding: 0;
                            margin: 0
                        }

                        .c5 {
                            margin-left: 21.3pt;
                            padding-left: 0pt
                        }

                        .c14 {
                            height: 12pt
                        }

                        .c9 {
                            height: 90pt
                        }

                        .c13 {
                            text-indent: 36pt
                        }

                        .c12 {
                            height: 0pt
                        }

                        .title {
                            padding-top: 0pt;
                            color: #000000;
                            font-size: 26pt;
                            padding-bottom: 3pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        .subtitle {
                            padding-top: 0pt;
                            color: #666666;
                            font-size: 15pt;
                            padding-bottom: 16pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        li {
                            color: #000000;
                            font-size: 12pt;
                            font-family: "Arial"
                        }

                        p {
                            margin: 0;
                            color: #000000;
                            font-size: 12pt;
                            font-family: "Arial"
                        }

                        h1 {
                            padding-top: 24pt;
                            color: #000000;
                            font-weight: 700;
                            font-size: 20pt;
                            padding-bottom: 6pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        h2 {
                            padding-top: 18pt;
                            color: #000000;
                            font-size: 12pt;
                            padding-bottom: 6pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        h3 {
                            padding-top: 16pt;
                            color: #434343;
                            font-size: 14pt;
                            padding-bottom: 4pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        h4 {
                            padding-top: 0pt;
                            color: #000000;
                            font-weight: 700;
                            font-size: 12pt;
                            padding-bottom: 10pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        h5 {
                            padding-top: 12pt;
                            color: #666666;
                            font-size: 11pt;
                            padding-bottom: 4pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }

                        h6 {
                            padding-top: 12pt;
                            color: #666666;
                            font-size: 11pt;
                            padding-bottom: 4pt;
                            font-family: "Arial";
                            line-height: 1.15;
                            page-break-after: avoid;
                            font-style: italic;
                            orphans: 2;
                            widows: 2;
                            text-align: justify
                        }
                    </style>
                </head>

                <body class="c7">
                    <p class="c4"><span class="c0">除了由人民發動公投之外，依據《憲法》、《公民投票法》也有由行政、立法部門發動的公投，則必須要經過不同的程序：</span></p><a
                        id="t.2ce208fe40bf8ebeb889e74713e63dee4de1fa81"></a><a id="t.0"></a>
                    <table class="c16">
                        <tbody>
                            <tr class="c9">
                                <td class="c11" colspan="1" rowspan="1">
                                    <p class="c10"><span class="c0">重大政策之創制或複決</span></p>
                                    <p class="c10"><span class="c0">《公民投票法》第14、15條</span></p>
                                </td>
                                <td class="c8" colspan="1" rowspan="1">
                                    <ul class="c2 lst-kix_ontk7jkumbsj-0 start">
                                        <li class="c4 c5"><span
                                                class="c0">行政院、立法院對於認有提出公民投票之必要者，得附具主文、理由書，經立法院院會通過後十日內，交由主管機關辦理公民投票。</span></li>
                                        <li class="c4 c5"><span class="c0">經立法院院會否決者，自該否決之日起二年內，不得就該事項重行提出。</span></li>
                                    </ul>
                                </td>
                            </tr>
                            <tr class="c12">
                                <td class="c11" colspan="1" rowspan="1">
                                    <p class="c10"><span class="c0">憲法之複決案</span></p>
                                    <p class="c10"><span class="c0">《公民投票法》第15條</span></p>
                                </td>
                                <td class="c8" colspan="1" rowspan="1">
                                    <ul class="c2 lst-kix_ia1bhn391by9-0 start">
                                        <li class="c4 c5"><span class="c0">立法院依憲法之規定提出之複決案，經公告半年後，應於十日內交由主管機關辦理公民投票。</span></li>
                                        <li class="c4 c5"><span
                                                class="c0">其中本次模擬公民投票主文「我國選舉權年齡」訂於《憲法》第130條，依憲法增修條文第12條之規定，修正流程整理於下。</span></li>
                                        <li class="c4 c5"><span
                                                class="c0">但18歲公民是否擁有憲法複決案之公民投票權，白話文就是「十八歲選舉權修憲公投票」18歲能不能投？仍有待進一步釐清。</span></li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="c4 c14"><span class="c0"></span></p>
                    <p class="c4"><span class="c6">完成修憲需要經過哪些程序？</span></p>
                    <p class="c4"><span>一、由四分之一</span><span class="c0">立法委員提案：</span></p>
                    <p class="c1"><span
                            class="c0">第九屆立法院自2016年3月，陸續有包括國民黨籍盧秀燕立法委員、時代力量黃國昌立法委員與黨團、民進黨籍管碧玲、李俊俋、尤美女、陳其邁、陳亭妃、高志鵬、蘇巧慧等立法委員相繼提出與選舉權相關的修憲提案，共計9個。</span>
                    </p>
                    <p class="c4"><span class="c0">二、院會一讀：</span></p>
                    <p class="c1"><span class="c0">第九屆立法院截至目前，已經有8個涉及選舉權之修憲提案已完成一讀，交付修憲委員會審查。</span></p>
                    <p class="c4"><span class="c0">三、籌組修憲委員會：</span></p>
                    <p class="c1"><span
                            class="c0">修憲委員會人數為立法委員總額三分之一加一人，由各政黨（政團）依其院會席次比例分配，並依保障少數參與原則組成，由互選五名召集委員輪流主持。時代力量立法委員徐永明強調，過去已經在院會提案10次籌組修憲委員會、在程序委員會變更議程6次，最後仍是無疾而終。</span>
                    </p>
                    <p class="c1"><span
                            class="c0">上一次立法院組成修憲委員會，時任立法院長王金平2015年3月召集黨團協商，同月召開第8屆修憲委員會第1次全體委員會議。四、五月連續召開十場次公聽會，五月中至六月舉行第二次至第十一次全體委員會議，審查所有修憲提案，前九次會議，每次處理一個主題，各做結論。第十次會議總結並完成審查，全數送黨團協商。</span>
                    </p>
                    <p class="c4"><span class="c0">四、交付院會二讀、三讀：</span></p>
                    <p class="c4 c13"><span class="c0">立法委員總額3/4出席，出席委員3/4決議通過憲法修正案</span></p>
                    <p class="c4 c13"><span class="c0">第九屆立法院連署相關十八歲選舉權的憲法修正案，超過總額的3/4。</span></p>
                    <p class="c1"><span class="c0">第八屆立法院在2015/06/15修憲公投案三讀最後期限，國民黨委員拒絕出席院會，朝野協商破局，距離當時最高共識的十八歲選舉權修憲公投票，只差臨門一腳。</span>
                    </p>
                    <p class="c4"><span class="c0">五、交付人民複決：</span></p>
                    <p class="c4 c13"><span class="c0">有效同意票數超過選舉人總額半數（約需939萬票）。</span></p>
                    <p class="c3"><span class="c0"></span></p>
                    <p class="c3"><span class="c0"></span></p>
                    <p class="c3"><span class="c0"></span></p>
                    <p class="c4 c14"><span class="c0"></span></p>
                </body>
            </html>
            `,
        icon:
          "data:image/svg+xml;utf8;base64,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",
        images: []
      },
      {
        title: "社會在改變，世界在進步！",
        content: `
          <html>
            <head>
                <meta content="text/html; charset=UTF-8" http-equiv="content-type">
                <style type="text/css">
                    *{
                        font-size: 18px;
                        line-height: 1.5;
                    }
                    ol {
                        margin: 0;
                        padding: 0
                    }

                    table td,
                    table th {
                        padding: 0
                    }

                    .c4 {
                        color: #000000;
                        font-weight: 700;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 14pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c5 {
                        color: #000000;
                        font-weight: 400;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 12pt;
                        font-family: "Microsoft JhengHei";
                        font-style: normal
                    }

                    .c1 {
                        color: #000000;
                        font-weight: 400;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 12pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c3 {
                        color: #000000;
                        font-weight: 700;
                        text-decoration: none;
                        vertical-align: baseline;
                        font-size: 18pt;
                        font-family: "Arial";
                        font-style: normal
                    }

                    .c2 {
                        padding-top: 0pt;
                        padding-bottom: 10pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .c0 {
                        padding-top: 0pt;
                        padding-bottom: 10pt;
                        line-height: 1.15;
                        orphans: 2;
                        widows: 2;
                        text-align: left
                    }

                    .c6 {
                        background-color: #ffffff;
                        max-width: 481.9pt;
                        padding: 56.7pt 56.7pt 56.7pt 56.7pt
                    }

                    .title {
                        padding-top: 0pt;
                        color: #000000;
                        font-size: 26pt;
                        padding-bottom: 3pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    .subtitle {
                        padding-top: 0pt;
                        color: #666666;
                        font-size: 15pt;
                        padding-bottom: 16pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    li {
                        color: #000000;
                        font-size: 12pt;
                        font-family: "Arial"
                    }

                    p {
                        margin: 0;
                        color: #000000;
                        font-size: 12pt;
                        font-family: "Arial"
                    }

                    h1 {
                        padding-top: 24pt;
                        color: #000000;
                        font-weight: 700;
                        font-size: 20pt;
                        padding-bottom: 6pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h2 {
                        padding-top: 18pt;
                        color: #000000;
                        font-size: 12pt;
                        padding-bottom: 6pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h3 {
                        padding-top: 16pt;
                        color: #434343;
                        font-size: 14pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h4 {
                        padding-top: 0pt;
                        color: #000000;
                        font-weight: 700;
                        font-size: 12pt;
                        padding-bottom: 10pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h5 {
                        padding-top: 12pt;
                        color: #666666;
                        font-size: 11pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }

                    h6 {
                        padding-top: 12pt;
                        color: #666666;
                        font-size: 11pt;
                        padding-bottom: 4pt;
                        font-family: "Arial";
                        line-height: 1.15;
                        page-break-after: avoid;
                        font-style: italic;
                        orphans: 2;
                        widows: 2;
                        text-align: justify
                    }
                </style>
            </head>

            <body class="c6">
                <p class="c2"><span
                        class="c1">為了解民眾是否因《公民投票法》已經下修公民投票年齡門檻後，對於「18歲選舉權修憲案」的支持意向及態度是否產生變化，推動十八歲公民權不遺餘力的台少盟與東森新聞雲民調中心合作，於2018年三月進行80小時網路民調，共有1,190位網友填寫有效問卷，並發佈民調結果。</span>
                </p>
                <p class="c2"><span
                        class="c1">本次民調針對擁有複決《憲法》修正案的公民投票權的門檻進一步提問。民調結果顯示同意年滿18歲者可以投「選舉權修憲案」（45.3%）與不同意者（46.9%）的比例相當。顯示民眾對於公投法賦予的創制複決權利與修憲賦予的公投權利未必全然清楚，行政院及中選會、教育部等應藉由新的公投法加強宣導，積極研議各種排除投票障礙、公民教育與促進社會對話的選民教育等措施。</span>
                </p>
                <p class="c2"><span class="c4">看看其他國家做了什麼？</span></p>
                <p class="c2">
                    <span>當</span><span>《公民投票法》修法降低年齡門檻之後，</span><span>不同意下修擴大選舉權至18歲的民意（43.1%）較過去大幅降低，同意者比例（48.6%）也逐漸升高</span><span>。</span><span>顯見國家或政黨一旦主動賦予十八歲公民權利，將會帶動人民對於青年的參政權利持正向支持的態度。</span>
                </p>
                <p class="c2"><span
                        class="c5">以日本為例，日本在1945年公布新憲法投票年齡從25歲下修到20歲後，國會智庫自2007年起開始研議，首相安倍晉三2012年競選時將「降低投票年齡」作為首要政見，並積極推動，參議院在2014及2015年分別通過《國民投票法》及《公職選舉法》修正案，並於2016年參議院選舉時落實。</span>
                </p>
                <p class="c0"><span
                        class="c1">韓國總統文在寅為2018年3月正式主動提交包括「將法定最低投票年齡從19歲降為18歲」等修憲案至國會審議，青瓦台民政首席祕書官曹國提出修憲版本的記者會表示「OECD共34個會員國中，除南韓外所有國家都是賦予滿18歲、甚至更低年齡的國民選舉權。行政法上，18歲就能依自身意志就業和結婚，也能成為8級以下的公務員，兵役和納稅義務也都能盡到。」但未通過國會審議。</span>
                </p>
                <p class="c2"><span
                        class="c1">觀諸世界各國，日本距離前一次修正投票年齡71年，韓國上一次修憲距今已有30年，正因和台灣都面臨同樣高修憲門檻的困境，皆是由執政黨帶動支持賦予青年積極的參政權利，小英總統應該要更加積極兌現其修憲的承諾，並針對修憲門檻過高的問題積極找解方，包括責成立法院盡速成立修憲委員會、中選會積極進行大法官釋憲。</span>
                </p>
            </body>
          </html>`,
        icon:
          "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPGc+Cgk8Y2lyY2xlIHN0eWxlPSJmaWxsOiMyRDQwNEU7IiBjeD0iMjU2IiBjeT0iMjU2IiByPSIyNTYiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiM0OEIxOUI7IiBkPSJNNTEyLDI1NmMwLTUxLjM2My0xNS4xMjQtOTkuMTkxLTQxLjE2NS0xMzkuMjc1YzAsMC0xNC42MDQsMjEuMzM0LTExLjg2LDM1LjA0NyAgIGMyLjc0MiwxMy43MTUsMTguODU1LDE0Ljc2MiwxNy4yLDI0LjgyMnMtMTMuNTQxLTIuODc5LTI4LjE3MiwyMy42MzNjLTE0LjYzLDI2LjUxNC03LjMxMiw2My4wOTYsMTMuNzE0LDY1LjgzNCAgIEM0ODIuNzQ0LDI2OC43OTcsNTEyLDI1Niw1MTIsMjU2eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6IzQ4QjE5QjsiIGQ9Ik0zMjMuMjMsOC45MmMyOS43OTcsOC4wODgsNTcuNDM0LDIxLjQyNCw4MS44NTcsMzguOTUxYzAsMC0yOS42ODQtNC44OTYtNDAuOTI5LDUuMTU4ICAgYy0xMS4yNDQsMTAuMDU3LTI3LjY0MywzMy44MzItNDAuOTI5LDBDMzA5Ljk0NSwxOS4xOTksMzIzLjIzLDguOTIsMzIzLjIzLDguOTJ6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojNDhCMTlCOyIgZD0iTTYzLjUxOSw4Ny4yMTlDMTEwLjQzNywzMy43NTQsMTc5LjI3NSwwLDI1NiwwYzAsMC0xNy4zNjgsMTAuNTE2LDE1LjU0NiwyOC4zNDQgICBjMzIuOTE1LDE3LjgzLDE3LjgyOCwyNi4wNTcsMTAuOTcxLDMxLjU0M2MtNi44NTYsNS40ODYtMTguNzQ5LTEwLjk3MS0yNi41MTctMjEuOTQxYy03Ljc2OS0xMC45NzMtNDEuMTMyLTI3Ljg4NS02Ni43MzQtMTguNzQgICBjLTI1LjYwMSw5LjE0NS00Ny41MzksMTUuOS00My44ODUsMjQuNDA4YzMuNjUzLDguNTA2LDQ3LjUzOS03Ljk0NSw2My45OTYtNy4wMzVjMTYuNDU3LDAuOTEyLDEwLjk3MSwxMC45NjctNC41NjksMjIuODU0ICAgYy0xNS41NDIsMTEuODg3LTE3LjM3NCwyNi41MTQtMC45MTYsMzUuNjU2YzE2LjQ1Niw5LjE0NiwzNi41NjYsMTAuMDYxLDQxLjE0Myw0LjU3NmM0LjU3NC01LjQ4Ni04LjIyOS00MS4xNDMsMjIuODU4LTI1LjYwMiAgIHM1Ni42ODgsMjQuNjkxLDMxLjA4Nyw0Ny41NDVjLTI1LjYwMiwyMi44NTItNTQuODU3LDQ4LjQ2MS01NS43NzMsNjMuMDg0Yy0wLjkxNiwxNC42MjUsOS4xNDYsMjYuNTIsMy42NiwyNy40MyAgIGMtNS40ODYsMC45MS0xMC41MjEtNS45NDEtMTQuMTc2LTEwLjk3M2MtMy42NTMtNS4wMjktMjAuNTcxLTYuODU1LTI4Ljc5OS0zLjY1OGMtOC4yMjksMy4xOTctMjMuNzc0LDE1LjU0MS0xNS4wODYsMjcuNDI4ICAgYzguNjg5LDExLjg4OSwyMC41NjUsNi4zOTYsMzIuNDU0LDExLjg4M2MxMS44ODcsNS40ODYsMjIuOTcyLDI2LjM2NSwyMC42OTYsMzEuMDg0Yy0yLjI3Niw0LjcxNy0xMi40MDktMS4yNTYtMjAuNjk2LTE3LjM2OSAgIGMtOC4yODktMTYuMTE1LTIzLjgzNS01LjQ4Ni0zNC43NzMtOC4yMjljLTEwLjkzOS0yLjc0Mi0xOS4xNjgtNC41Ny0zMC4xNC0yMy43NzFjLTEwLjk3Mi0xOS4xOTktMzMuNjg3LTI0LjU3Mi00Mi45NjktMzUuNjU2ICAgYy0yNi41ODktMzEuNzUtMjQuNjg3LTU1Ljc3MS0zMC4xNzItNjYuNzQyQzc3LjcyLDEwNS4xNDUsNjMuNTE5LDg3LjIxOSw2My41MTksODcuMjE5eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6IzQ4QjE5QjsiIGQ9Ik0yODAuNjg1LDI1OS42NThjMCwwLDI3LjQyOSwyLjczOCw0MS4xNDMsMTQuNjI3YzEzLjcxNCwxMS44ODcsMTUuNTQ2LDE2LjQ2MSwzNi41NzMsMjEuMDMxICAgYzIxLjAyNyw0LjU2OCwzMC4xNzIsMTYuNDUxLDE2LjQ1NywzOS4zMTFjLTEzLjcxNCwyMi44NTctMzguNDA0LDU5LjQzLTUwLjI4Nyw3MC40MDJjLTExLjg4MiwxMC45NzMtMjYuNTEyLDIwLjExNS0zMS45OTgsMzguNCAgIGMtNS40ODUsMTguMjgzLTcuMzE3LDI5LjI0OCw0LjU3LDM2LjU2OGMwLDAtNi4zOTYsMTUuNTQ1LTIxLjAyNi00LjU3Yy0xNC42MzEtMjAuMTE3LTIuNzQ0LTQzLjg4NSwwLTU3LjYgICBjMi43NDItMTMuNzEzLDEwLjA1NS01NC44NTIsNS40ODQtNjQuOTE0Yy00LjU2OC0xMC4wNTktMjUuNjAxLTE2LjQ2MS0zMS4wODctMzcuNDg2ICAgQzI0NS4wMjgsMjk0LjQwMSwyNTQuNjI5LDI1My40ODMsMjgwLjY4NSwyNTkuNjU4eiIvPgoJPHBhdGggc3R5bGU9Im9wYWNpdHk6MC42O2ZpbGw6IzI1Mzc0NDtlbmFibGUtYmFja2dyb3VuZDpuZXcgICAgOyIgZD0iTTc0Ljk4LDc0Ljk4M2M5OS45NzUtOTkuOTc3LDI2Mi4wNjItOTkuOTc1LDM2Mi4wMzgsMCAgIGM5OS45NzYsOTkuOTczLDk5Ljk3NiwyNjIuMDYyLDAuMDAxLDM2Mi4wMzdjMCwwLDExNi4xNDgtMTUzLjU5LTQ4LjI5My0zMTguMDMxQzIyNC4yODQtNDUuNDUzLDc0Ljk4LDc0Ljk4Myw3NC45OCw3NC45ODN6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==",
        images: [
          "https://i.imgur.com/TprHLi3.png",
          "https://i.imgur.com/5NJl0ih.png",
          "https://i.imgur.com/2LEWSi0.png",
          "https://i.imgur.com/hy2wuCB.jpg"
        ]
      }
    ]
  }),
  methods: {
    clickRights(index) {
      this.dialogTitle = this.voteTypes[index].title;
      this.dialogContent = this.voteTypes[index].content;
      this.dialogImages = this.voteTypes[index].images;
      this.dialog = true;
    },
    closeDialog() {
      setTimeout(() => {
        this.dialogTitle = "";
        this.dialogContent = "";
        this.dialogImages = [];
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.taiwan-vote-type-layout {
  height: 100%;
}

.taiwan-vote-type-title {
  // text-align: left;
  font-size: 2em;
}

@keyframes wave {
  0%,
  100% {
    transform: translateY(0px) scale(1);
  }
  50% {
    transform: translateY(-5px) scale(1);
  }
}

.eighteen-vote-right-icon {
  transition: 0.5s;
  margin-top: 50px;
  &:hover {
    transition: 0.5s;
    animation: wave 1.5s infinite linear;
  }
}

.taiwan-vote-type-item {
  font-size: 18px;
  font-weight: bold;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
  h3 {
    text-align: center;
  }
}
</style>
